import "./PageNotFound.css";
const PageNotFound = ()=>{
    return(
        <>
        </>
    )
}
export default PageNotFound; 